import { RiCloseFill } from "react-icons/ri"
import { SidePopupContainer, FlexColumn, AppSpan, Button, FlexRow, CustomContainer, AppText } from "src/style"
import {ReactComponent as DebitCard} from 'src/assets/img/card-icon.svg'
import {ReactComponent as BankTransferIcon} from 'src/assets/img/bank-transfer-icon.svg'
import { useNotifier } from "react-pop-notifier"

export const PaymentMethod: React.FC<any> = ({close, onTypeSelection}) => {
    const {notifier} = useNotifier()

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Choose your payment method</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#667085'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <CustomContainer topMargin="1.5" minHeight="24">
                    <FlexRow 
                        gap="1.5" minHeight="6.7"
                        radius="0.8" padding="1.6"
                        borderColor="#EAECF0"
                        className="payment-method-option"
                        //onClick={() => onTypeSelection('card')}
                        onClick={() => notifier.show('This feature is currently not available', 'Information', 'success')}
                    >
                        <DebitCard className="icon-component" />
                        <AppText 
                            fontWeight="600" color="#344054" 
                            cursor="pointer"
                        >
                            Card Payment
                        </AppText>
                    </FlexRow>
                    <FlexRow 
                        gap="1.5" minHeight="6.7"
                        radius="0.8" padding="1.6"
                        borderColor="#EAECF0" topMargin="2"
                        className="payment-method-option"
                        onClick={() => onTypeSelection('bank-transfer')}
                    >
                        <BankTransferIcon className="icon-component" />
                        <AppText 
                            fontWeight="600" color="#344054" 
                            cursor="pointer"
                        >
                            Bank Transfer
                        </AppText>
                    </FlexRow>
                </CustomContainer>
            </FlexColumn>
        </>
    )
}